
        Component.define('pet-testimonials', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $slider         = $el.find('.wrapper-slider');

$slider.slick({
    infinite: true,
    slidesToShow: 3,
    dots: false,
    arrows: false,
    responsive: [
        {
          breakpoint: 980,
          settings: {
            slidesToShow: 1,
            infinite: true,
            dots: true,
          }
        },
    ]
});


        });